export const sampleModelPortfolio = () => {
    return {
        id: 'ff56b08b-dde3-4db5-b783-1b8dcdfed56f',
        title: 'Lundsbank ISA Risk 4',
        externalId: '0001',
    };
};
